import { useHistory } from 'react-router-dom';
import locales from 'locales';
import { getLocale } from 'helpers/path-helpers';

interface UseTranslateReturnType {
  locale: string;
  t: (key: string, ...args: string[]) => string;
}

function deepFind(
  obj: LocaleType,
  path: string,
): string | TranslationWithArgs | undefined | LocaleType {
  const paths = path.split('.');
  let current = obj;

  for (path of paths) {
    if (current[path] === undefined) {
      return undefined;
    } else {
      current = current[path] as LocaleType;
    }
  }

  return current;
}

export function useTranslate(): UseTranslateReturnType {
  const history = useHistory();
  const locale = getLocale(history.location.pathname);

  const translate = (key: string, ...args: string[]): string => {
    const translation = deepFind(locales[locale], key);

    if (translation === undefined) {
      console.warn(`Translation for '${key}' not found`);
    }

    if (typeof translation === 'function') {
      return translation(...args);
    }

    return translation as string;
  };

  return {
    locale,
    t: translate,
  };
}
